import BursaryLayout from './BursaryLayout';
import { useEffect, useState } from 'react';
import M from 'materialize-css/dist/js/materialize.min';
import CustomizedSnackbars from "../../Feedback";
import { IoIosAddCircle } from 'react-icons/io';
import { useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import { addFeesAction } from '../../../Firebase/actions/addFeesAction';

const AddFees = ({ addFeesAction, addFeesSuccess, addFeesError, resetSuccess }) => {
    const { id } = useParams();
    const [ paid, setPaid ] = useState('');
    const [ balance, setBalance ] = useState('');
    const [ date, setDate ] = useState('');
    const [ term, setTerm ] = useState('');
    const [ error, setError ] = useState(false);

    const [ openFeedback, setOpenFeedback ] =  useState(false); 
    const [ feedbackText, setFeedbackText ] =  useState(''); 
    const [ severity, setSeverity ] =  useState(null); 

    const handleSubmit = (e) => {
        e.preventDefault();

        if(paid === '' || balance === '' || date === '' || term === '') {
            setError(true);
            return ;
        } else {
            setError(false);

            let fees = {
                feesPaid: paid,
                feesBalance: balance,
                feesDate: date,
                feesTerm: term,
                id
            }
            // to database
            //console.log(fees)
            addFeesAction(fees);
            document.getElementById('Btn').classList.add('is-loading');
            
        }
    }
    useEffect(() => {
        var elems = document.querySelectorAll('select');
        M.FormSelect.init(elems, {
            dropdownOptions: {
                coverTrigger: false, 
                hover: true
            }
        });

        if(addFeesSuccess) {
            //reset form
            setPaid('');
            setBalance('');
            setDate('');
            
            //on success
            setFeedbackText('Fees record added.');
            setSeverity('success');
            setOpenFeedback(true);
            document.getElementById('Btn').classList.remove('is-loading');
            
            resetSuccess();
        }

        if(addFeesError) {
            //on error
            setFeedbackText('Error occured.');
            setSeverity('error');
            setOpenFeedback(true);
            document.getElementById('Btn').classList.remove('is-loading');
        }

    }, [addFeesSuccess, addFeesError, resetSuccess]);

    return ( 
        <BursaryLayout>
            <div className="pt-4">
                <div className="container">
                    <h5 className="title is-size-5-touch has-text-weight-semibold mb-2 grey-text text-darken-3">Name Surname:</h5>
                    <div className="divider mb-5"></div>

                    <form className="row mt-5" onSubmit={handleSubmit}>
                        <div className="col s12 m4 l4">
                            <div className="input-field">
                                <input id="paid" type="text" onChange={(e) => setPaid(e.target.value)} value={paid} />
                                <label htmlFor="paid" className="active">Fees Paid:</label>
                            </div>
                        </div>
                        <div className="col s12 m4 l4">
                            <div className="input-field">
                                <input id="balance" type="text" onChange={(e) => setBalance(e.target.value)} value={balance} />
                                <label htmlFor="balance" className="active">Balance:</label>
                            </div>
                        </div>
                        <div className="col s12 m2 l2">
                            <div className="input-field">
                                <input id="date" type="text" onChange={(e) => setDate(e.target.value)} value={date} />
                                <label htmlFor="date" className="active">Date: (01/01/21)</label>
                            </div>
                        </div>
                        <div className="col s12 m2 l2">
                            <div className="input-field">
                                <select onChange={(e) => setTerm(e.target.value)} value={term} >
                                <option value="" disabled>Select Term</option>
                                    <option value="Term One">Term One</option>
                                    <option value="Term Two">Term Two</option>
                                    <option value="Term Three">Term Three</option>
                                </select>
                                <label>Term: </label>
                            </div>
                        </div>
                        <div className="control">
                            <button
                                className="button is-success mt-3"
                                id="Btn"
                            >
                                <span className="icon">
                                <IoIosAddCircle size="1.25rem" color="white"/>
                                </span>
                                <span className="white-text">Add Fees Record</span>
                            </button>
                        </div>
                    </form>
                    {
                        error && <p className="mt-1 main-color-text">Please fill all the fields.</p>
                    }
                </div>
            </div>
            <CustomizedSnackbars openSuccess={openFeedback} feedbackText={feedbackText} severity={severity} />
        </BursaryLayout>
     );
}

const mapStateToProps = (state) => {
    //console.log(state)
    return {
        addFeesSuccess: state.addFees.addFeesSuccess,
        addFeesErrror: state.addFees.addFeesErrror
    }
    
}
 

const mapDispatchToProps = (dispatch) => {
    return {
        addFeesAction: (data) => dispatch(addFeesAction(data)),
        resetSuccess: () => dispatch({ type: "ADD_FEES", success: false })
    };
};
  
export default connect(mapStateToProps, mapDispatchToProps)(AddFees);